import { render, staticRenderFns } from "./ExtrabonusTooltip.vue?vue&type=template&id=84336876"
import script from "./ExtrabonusTooltip.vue?vue&type=script&lang=js"
export * from "./ExtrabonusTooltip.vue?vue&type=script&lang=js"
import style0 from "./ExtrabonusTooltip.vue?vue&type=style&index=0&id=84336876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports